module.exports = __webpack_public_path__ + "media/images/icons/mail-circle-8568aa5020e3bbd3d23c5da15ff17bb4.svg";